import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../helpers/axiosInstance";
import { BulkVolunteer } from "../../helpers/bulkVolunteerMockData";

interface UsersState {
  data: BulkVolunteer[];
  loading: boolean;
  error: string | null;
}

const initialState: UsersState = {
  data: [],
  loading: false,
  error: null,
};

export const RegisterBulkVolunteers = createAsyncThunk(
  "volunteer/RegisterBulkVolunteers",
  async (formData: FormData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "api/eventregistration/createBulkRegistrationCompleted",
        formData,
      );
      return response.data as BulkVolunteer[];
    } catch (error) {
      return rejectWithValue("Failed to fetch users");
    }
  },
);

const BulkVolunteerRegistrationSlice = createSlice({
  name: "users",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(RegisterBulkVolunteers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(RegisterBulkVolunteers.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(RegisterBulkVolunteers.rejected, (state, action) => {
        state.loading = false;
        state.error = (action.payload as string) || "Something went wrong";
      });
  },
});

export default BulkVolunteerRegistrationSlice.reducer;
